import { type RefObject } from 'react';

const getFileInputClickHandler = (ref: RefObject<HTMLInputElement>) => () => {
  if (!ref.current) {
    return;
  }

  ref.current.value = '';
  ref.current.click();
};

export default getFileInputClickHandler;
